<script setup>
import { useAttrs } from 'vue'
import { useTradeInStore } from '../tradeInStore.js'
import tradeInWidget from './tradein-widget.ce.vue'
import Popup from './utils/popup.vue'

const props = defineProps({
  slotContent: {
    type: String,
    default: ''
  }
})

const tradeInStore = useTradeInStore()

const attrs = useAttrs()
const layout = attrs.layout
const style = attrs.style
</script>

<template>
  <div v-if="tradeInStore.error">
    <div class="bg-red-200 p-4 text-red-800 antialiased">
      <div>
        <h1 class="font-bold text-4xl">Systemfehler</h1>
        <pre class="mt-4 text-sm leading-none">{{ tradeInStore.errorMessage }}</pre>
      </div>
    </div>
  </div>
  <div v-else>
    <button
      @click="tradeInStore.openTradeInWidget()"
      :class="[
        layout === 'unstyled'
          ? []
          : [
              'bg-brand',
              'hover:bg-brand-darker',
              'text-white',
              'font-bold',
              'py-2',
              'px-4',
              'rounded'
            ]
      ]"
      :style="[style]"
    >
      <slot>{{ props.slotContent || 'Inzahlungnahme' }}</slot>
    </button>
    <Popup v-if="tradeInStore.showTradeInWidget">
      <div>
        <tradeInWidget :client-id="tradeInStore.clientId" />
      </div>
    </Popup>
  </div>
</template>

<style>
@import '../index.css';
</style>
